export type Provider = "google" | "microsoft" | "titan";
export const providerName = (p: string) =>
  p === "titan"
    ? "Online meeting"
    : p === "google"
      ? "Google Meet"
      : "Microsoft Teams";
export interface TimeWindow {
  start: string;
  end: string;
}
export interface EventType {
  id: string;
  title: string;
  duration: number;
  buffer_before: number;
  buffer_after: number;
  notice_hours: number;
  horizon_days: number;
  daily_limit: number;
  providers: Provider[];
  enabled: boolean;
}
export interface Profile {
  slug: string;
  display_name: string;
  timezone: string;
  enabled: boolean;
  hours: Array<{ day: number; windows: TimeWindow[] }>;
  overrides: Array<{ date: string; windows: TimeWindow[] }>;
  event_types: EventType[];
}
export interface Connection {
  provider: Provider;
  configured: boolean;
  connected: boolean;
  /** Guests can book this platform now: connected, meeting link set, and email ready. */
  guestReady: boolean;
  settings: {
    calendarId: string;
    busyCalendarIds: string[];
    meetingSupported: boolean;
    meetingUrl?: string;
    username?: string;
    region?: "godaddy" | "global" | "eu";
  } | null;
}
export interface BookingSettings {
  profile: Profile | null;
  providers: Connection[];
  webOrigin: string;
}
export interface PublicProfile {
  name: string;
  slug: string;
  timezone: string;
  types: Array<{
    id: string;
    title: string;
    duration: number;
    providers: Provider[];
  }>;
}
export interface BookingResult {
  id: string;
  status: string;
  start: string;
  end: string;
  provider: Provider;
  meetingUrl: string | null;
  manageToken: string;
  host?: string;
  title?: string;
  slug?: string;
  typeId?: string;
}
export const fieldClass =
  "w-full rounded-lg border border-white/15 bg-bg-tertiary px-3 py-2 text-text-primary";
export const panelClass =
  "rounded-xl border border-white/10 bg-bg-secondary p-5 space-y-4";
